module.exports = __webpack_public_path__ + "img/logo-header-75px.1e2b6d6d.jpg";